import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

const FILLED_COLOR = '#FFB800'

export type StarProps = {
  size?: number
  filled?: boolean
  emptyColor?: string
} & ClassNameProps &
  React.SVGAttributes<SVGSVGElement>

export const Star: React.FC<StarProps> = ({
  className,
  filled,
  size = 16,
  ...svgProps
}) => {
  return (
    <Root
      data-filled={filled}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M8 4.68583L8.77148 6.59548L9.00781 7.17454L9.60547 7.22998L11.5703 7.41273L10.082 8.77413L9.62891 9.18891L9.76367 9.80288L10.207 11.8255L8.51367 10.7577L8 10.4333L7.48633 10.7577L5.79297 11.8255L6.23633 9.80288L6.37109 9.18891L5.91797 8.77413L4.42969 7.41273L6.39453 7.23203L6.99219 7.17659L7.22852 6.59548L8 4.68583ZM8 2L6.30664 6.18481L2 6.58316L5.26172 9.56879L4.29297 13.9979L8 11.6612L11.707 14L10.7383 9.56879L14 6.58316L9.69336 6.18481L8 2Z"
        fill="currentColor"
      />
      {filled ? (
        <path
          d="M8 2L6.30664 6.18481L2 6.58316L5.26172 9.56879L4.29297 13.9979L8 11.6612L11.707 14L10.7383 9.56879L14 6.58316L9.69336 6.18481L8 2Z"
          fill="currentColor"
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.svg`
  --star-filled-color: ${FILLED_COLOR};
  --star-empty-color: var(--text-7);
  --star-empty-color-hover: var(--text-9);

  transition: color 0.15s ease-in-out;

  &[data-filled='true'] {
    color: var(--star-filled-color);
  }
  &[data-filled='false'] {
    color: var(--star-empty-color);
    &:hover {
      color: var(--star-empty-color-hover);
    }
  }
`
